"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtomList = void 0;

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var AtomList = function AtomList(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        className: "listaGeneral",
        children: content.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            children: item
          }, "item" + index);
        })
      })
    })
  }, "list-".concat(content.length));
};

exports.AtomList = AtomList;